export default __webpack_public_path__ + "static/media/dv3.7e00f4a2.svg";